import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Disclosure } from '@headlessui/react'
import { ChevronDown, AwardIcon } from 'lucide-react'
import pluralize from 'pluralize'
import { Button } from '../../ui/button'
import Badge from '../../leevo_ui/Badge/Badge'
import StudentsDrawer from '../../leevo_ui/KlassForm/StudentsDrawer'

function EnrollmentSection({ students, maxStudents, onChange, facilityId, selectedSkillLevels }) {
  const [showStudentsDrawer, setShowStudentsDrawer] = useState(false)

  const enrolledCount = students.filter((s) => s.selected).length

  function getSpotsInfo() {
    if (!maxStudents) {
      return { text: 'Unlimited spots', color: 'green' }
    }

    const spotsLeft = maxStudents - enrolledCount

    if (spotsLeft >= 4) {
      return { text: `${spotsLeft} ${pluralize('spot', spotsLeft)} available`, color: 'green' }
    } else if (spotsLeft > 0) {
      return { text: `${spotsLeft} ${pluralize('spot', spotsLeft)} available`, color: 'orange' }
    } else {
      return { text: 'Full', color: 'red' }
    }
  }

  const spotsInfo = getSpotsInfo()

  return (
    <>
      <Disclosure>
        {({ open }) => (
          <div className="bg-white border border-gray-200 rounded-lg">
            <Disclosure.Button className="flex items-center justify-between w-full px-4 py-3 text-left">
              <div className="flex items-center space-x-2">
                <AwardIcon className="w-5 h-5 text-purple-600" />
                <h3 className="text-base font-semibold text-gray-900">Enrollment</h3>
              </div>
              <div className="flex items-center space-x-3">
                <Badge text={spotsInfo.text} color={spotsInfo.color} />
                <ChevronDown
                  className={`w-5 h-5 text-gray-500 transition-transform ${open ? 'transform rotate-180' : ''}`}
                />
              </div>
            </Disclosure.Button>

            <Disclosure.Panel className="px-4 pb-4 space-y-4 border-t border-gray-200">
              <div className="mt-4">
                <p className="mb-4 text-sm text-gray-600">
                  If you must add students manually, you should add them to the package for this class instead. Use this
                  section only for exceptional cases.
                </p>

                <div className="flex items-center justify-between p-3 rounded-md bg-gray-50">
                  <span className="text-sm text-gray-700">Current Students</span>
                  <span className="text-lg font-semibold text-gray-900">{enrolledCount}</span>
                </div>

                <Button
                  type="button"
                  variant="outline"
                  className="w-full mt-3"
                  onClick={() => setShowStudentsDrawer(true)}
                >
                  Manage Students
                </Button>
              </div>
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>

      <StudentsDrawer
        open={showStudentsDrawer}
        onOpenChange={setShowStudentsDrawer}
        students={students}
        selectedSkillLevels={selectedSkillLevels}
        onChange={onChange}
        facilityId={facilityId}
      />
    </>
  )
}

EnrollmentSection.propTypes = {
  students: PropTypes.array.isRequired,
  maxStudents: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  facilityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  selectedSkillLevels: PropTypes.array.isRequired
}

export default EnrollmentSection
